import { P2GDropdown } from '@parcel2go/core-ui';

const MonthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

const DayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

/** The whole order history, with no date bound. Distinct from 'RECENT', which is the last 14 days. */
export const AllOrdersPeriod = 'ALLORDERS';

export const getMonthIndex = (date: string) => {
  let index = 0;
  MonthNames.forEach((m, i) => {
    if (m.toUpperCase().substring(0, 3) == date) {
      index = i;
    }
  });
  return index;
};

interface props {
  setPeriod: (period: string) => void;
  period: string;
  label: string;
  includeAllOrders?: boolean;
}

export interface PeriodDates {
  fromUnix: number;
  toUnix: number;
}

export interface ExtendedPeriod {
  value: string;
  count: number;
  text: string;
  day: string;
  date: number;
  month: string;
}

const getPickingListOptions = (days: number): ExtendedPeriod[] => {
  const dates: ExtendedPeriod[] = [];

  for (let index = 0; index < days; index++) {
    const x = new Date();
    x.setDate(x.getDate() - index);
    dates.push({
      value: `${MonthNames[x.getMonth()].substr(0, 3).toUpperCase()}_${x.getFullYear()}_${x.getDate()}`,
      text: `${DayNames[x.getDay()].substring(0, 3).toUpperCase()}\n${x.getDate()}`.toUpperCase(),
      count: 0,
      day: `${DayNames[x.getDay()]}`,
      date: x.getDate(),
      month: `${MonthNames[x.getMonth()]}`
    });
  }

  return dates.reverse();
};

const getDates = (includeAllOrders = false) => {
  const dates = [
    ...(includeAllOrders ? [{ value: AllOrdersPeriod, text: 'All Orders' }] : []),
    { value: 'DEFAULT', text: 'Last 30 Days' },
    { value: 'TODAY', text: 'Today' },
    { value: 'YESTERDAY', text: 'Yesterday' },
    { value: 'THISWEEK', text: 'This Week' },
    { value: 'LASTWEEK', text: 'Last Week' }
  ];
  for (let index = 0; index < 6; index++) {
    const x = new Date();
    x.setDate(1);
    x.setMonth(x.getMonth() - index);

    switch (index) {
      case 0:
        dates.push({
          value: `THISMONTH`,
          text: `This Month (${MonthNames[x.getMonth()].substr(0, 3)})`
        });
        break;

      case 1:
        dates.push({
          value: `LASTMONTH`,
          text: `Last Month (${MonthNames[x.getMonth()].substr(0, 3)})`
        });
        break;

      default:
        dates.push({
          value: `${MonthNames[x.getMonth()].substr(0, 3).toUpperCase()}_${x.getFullYear()}`,
          text: `${MonthNames[x.getMonth()]} ${x.getFullYear()}`
        });
    }
  }

  return dates;
};

const GetPeriodDisplay = (period: string) => {
  return getDates(true).find((x) => x.value === period)?.text || period;
};

const DashDateSelection: React.FC<props> = (props) => {
  return (
    <P2GDropdown
      options={getDates(props.includeAllOrders)}
      onChange={props.setPeriod}
      value={props.period}
      id="Date Range"
      label={props.label}
    />
  );
};

export { DashDateSelection, GetPeriodDisplay, getPickingListOptions };
